export default [
  {
    value: 'Code',
    label: '报销编号',
    order: 1,
    align: 'center',
    width: 140
  },{
    value: 'CostCompany',
    label: '所属主体',
    order: 16,
    align: 'center',
    width: 104
  }, {
    value: 'CostDeptName',
    label: '所属部门',
    order: 2,
    align: 'center',
    width: 104
  }, {
    value: 'OwnerCompanyName',
    label: '抬头企业',
    order: 18,
    align: 'center',
    width: 200
  }, {
    value: 'ApplyUserName',
    label: '申请人',
    order: 3,
    align: 'center',
    width: 90
  }, {
    value: 'Payee',
    label: '收款人',
    order: 4,
    align: 'center',
    width: 214
  }, {
    value: 'PayeeBankName',
    label: '开户行',
    order: 5,
    align: 'center',
    width: 240
  }, {
    value: 'PayeeBankAccount',
    label: '收款账号',
    order: 6,
    align: 'center',
    width: 240
  }, {
    value: 'TotalAmount',
    label: '报销总金额（元）',
    order: 7,
    align: 'center',
    width: 140,
    format: function (val) {
      return this.$common.moneyFormat(val)
    }
  },
  // {
  //   value: 'FinancialEntry',
  //   label: '一级科目',
  //   order: 8,
  //   align: 'center',
  //   width: 140,
  //   format: function (val) {
  //     const temp = this.$ReimburseSubject.find(item => item.Name == val);
  //     return temp && temp.Title || "";
  //   }
  // }, {
  //   value: 'FinancialSubEntry',
  //   label: '二级科目',
  //   order: 9,
  //   align: 'center',
  //   width: 140,
  //   format: function (val) {
  //     const temp = this.$ReimburseSubject.find(item => item.Name == val);
  //     return temp && temp.Title || "";
  //   }
  // },
  // {
  //   value: 'IsSubmitVoucher',
  //   label: '是否提交报销单',
  //   order: 10,
  //   align: 'center',
  //   width: 140,
  //   slotName: 'IsSubmitVoucher',
  // }, 
  {
    value: 'InvoiceType',
    label: '发票类型',
    order: 10,
    align: 'center',
    width: 140
  }, {
    value: 'IsSubmitInvoice',
    label: '纸质发票',
    order: 11,
    align: 'center',
    width: 140,
    slotName: 'IsSubmitInvoice',
  }, {
    value: 'ApplyDateTime',
    label: '申请时间',
    order: 12,
    align: 'center',
    width: 195,
    format: function (val) {
      return this.$common.timesToTime(val, true)
    }
  }, {
    value: 'Status',  // value名称取后端返回的字段
    label: '审核状态',
    order: 17,
    align: 'center',
    width: 140,
    slotName: 'Status',   // 插槽名字跟value一样
  },{
    value: 'IsFinancialPaid',
    label: '财务打款',
    order: 13,
    align: 'center',
    width: 140,
    slotName: 'IsFinancialPaid',
  }, {
    value: 'FinancialPayTime',
    label: '打款时间',
    order: 14,
    align: 'center',
    width: 195,
    format: function (val) {
      return this.$common.timesToTime(val, true)
    }
  }, {
    value: 'Remarks',
    label: '备注',
    order: 15,
    align: 'center',
    width: 240
  },
]